import { selector } from "recoil";

import { SortTypes } from "@constants";
import { DataType, IsolationCode } from "@types";

import {
  filterVaccinationState,
  filterIsolationState,
  sortTypeState,
  searchInputValueState,
} from "./retrievalstate";
import { originalDataState } from "./originaldata";

// 필터 - 접종한 백신
const vaccinationData = selector({
  key: "vaccinationData",
  get: ({ get }) =>
    get(originalDataState).filter(
      ({ canTravel, summaryEntrance, covid_vaccines }) => {
        const currentFilter = get(filterVaccinationState);

        switch (currentFilter) {
          case "all":
            return true;
          case "unvaccinated":
            return (
              !canTravel ||
              (summaryEntrance?.no_vaccination.covid_isolation
                .code as IsolationCode) !== ("NO_ENTRANCE" as IsolationCode)
            );
          default:
            return (
              !canTravel ||
              covid_vaccines?.some(({ code }) => code === currentFilter)
            );
        }
      }
    ),
});

// 필터 - 격리 여부
const isolationData = selector({
  key: "isolationData",
  get: ({ get }) => {
    const isolation = get(filterIsolationState);
    const prevData = get(vaccinationData);

    // 모두 체크 안되어 있을 시 필터링하지않음
    if (
      !isolation.vaccinationEntrance &&
      !isolation.vaccinationReturn &&
      !isolation.unVaccinationEntrance &&
      !isolation.unVaccinationReturn
    ) {
      return prevData;
    }

    return prevData.filter((data) => {
      const result = [];

      if (isolation.vaccinationEntrance) {
        result.push(
          data.summaryEntrance?.vaccination.covid_isolation.code ===
            ("NO" as IsolationCode) ||
            data.summaryEntrance?.vaccination.covid_isolation.code ===
              ("NO_NEGATIVE" as IsolationCode)
        );
      }
      if (isolation.vaccinationReturn) {
        result.push(
          data.summaryReturn?.vaccination.covid_isolation.code ===
            ("NO" as IsolationCode) ||
            data.summaryReturn?.vaccination.covid_isolation.code ===
              ("NO_NEGATIVE" as IsolationCode)
        );
      }
      if (isolation.unVaccinationEntrance) {
        result.push(
          data.summaryEntrance?.no_vaccination.covid_isolation.code ===
            ("NO" as IsolationCode) ||
            data.summaryEntrance?.no_vaccination.covid_isolation.code ===
              ("NO_NEGATIVE" as IsolationCode)
        );
      }
      if (isolation.unVaccinationReturn) {
        result.push(
          data.summaryReturn?.no_vaccination.covid_isolation.code ===
            ("NO" as IsolationCode) ||
            data.summaryReturn?.no_vaccination.covid_isolation.code ===
              ("NO_NEGATIVE" as IsolationCode)
        );
      }

      // and 조건
      return !data.canTravel || result.every((v) => v);
    });
  },
});

// 검색
const searchedData = selector({
  key: "searchedData",
  get: ({ get }) =>
    get(isolationData).filter(({ countryName, countryKey }) => {
      const nameKR = countryName;
      const nameEN = countryKey;

      // 검색 단어에 공백 제거
      const value = get(searchInputValueState).trim().replace(/\s/g, "");

      // 한글 검색
      const checkKRValue = nameKR?.includes(value);

      // 영어 검색 소문자로 통일, countryKey의 밸류에 공백은 %20로 되어있어 제거
      const checkENValue = nameEN
        ?.toLowerCase()
        .replace(/\%20/g, "")
        .includes(value.toLowerCase());

      return checkKRValue || checkENValue;
    }),
});

// 정렬 - 가나다, 인기순
const sortData = selector({
  key: "sortData",
  get: ({ get }) =>
    [...get(searchedData)].sort((a, b) => {
      const sortType = get(sortTypeState);

      if (sortType === SortTypes.favorite) {
        return b.view - a.view;
      } else if (sortType === SortTypes.asc) {
        return a.countryName.toLowerCase() > b.countryName.toLowerCase()
          ? 1
          : -1;
      }
      return 0;
    }),
});

export const filterdDataState = selector<DataType[]>({
  key: "filterdData",
  get: ({ get }) => get(sortData),
});

export const filteredDataDivideState = selector<{
  travelPossible: DataType[];
  travelImpossible: DataType[];
}>({
  key: "filteredDataDivide",
  get: ({ get }) => {
    const filterdData = get(filterdDataState);

    return {
      travelPossible: filterdData.filter((value) => !value.canTravel),
      travelImpossible: filterdData.filter((value) => value.canTravel),
    };
  },
});
